import accessoriesSvg from './icon-accessories.svg'
import apiSvg from './icon-api.svg'
import chartsSvg from './icon-charts.svg'
import columnsSvg from './icon-columns.svg'
import componentsSvg from './icon-components.svg'
import dataSvg from './icon-data.svg'
import editCellsSvg from './icon-edit-cells.svg'
import filterSvg from './icon-filter.svg'
import groupSvg from './icon-group.svg'
import importExportSvg from './icon-import-export.svg'
import informationSvg from './icon-information.svg'
import interactivitySvg from './icon-interactivity.svg'
import renderCellsSvg from './icon-render-cells.svg'
import rowsSvg from './icon-rows.svg'
import scrollSvg from './icon-scroll.svg'
import selectionSvg from './icon-selection.svg'
import styleSvg from './icon-style.svg'
import testSvg from './icon-test.svg'
import miscSvg from './icon-misc.svg'

const icons = {
    accessories: accessoriesSvg,
    api: apiSvg,
    charts: chartsSvg,
    columns: columnsSvg,
    components: componentsSvg,
    data: dataSvg,
    'edit-cells': editCellsSvg,
    filter: filterSvg,
    group: groupSvg,
    'import-export': importExportSvg,
    information: informationSvg,
    interactivity: interactivitySvg,
    'render-cells': renderCellsSvg,
    rows: rowsSvg,
    scroll: scrollSvg,
    selection: selectionSvg,
    style: styleSvg,
    test: testSvg,
    misc: miscSvg,
}

export default icons;
